module.exports = __webpack_public_path__ + "img/1.92a2df18.jpeg";